import React from 'react';

const Phone = () => {
    return (
        <svg width={16} height={15.954} viewBox="0 0 16 15.954">
            <path
                d="M14.018 8.8a2.526 2.526 0 01-.538-.1 7.579 7.579 0 01-1.052-.313 1.606 1.606 0 00-1.991.8l-.177.361a9.779 9.779 0 01-2.136-1.606 9.779 9.779 0 01-1.606-2.129l.337-.225a1.606 1.606 0 00.8-1.991 8.294 8.294 0 01-.313-1.052 7.756 7.756 0 01-.1-.546 2.409 2.409 0 00-2.409-2H2.431A2.409 2.409 0 00.018 2.738a15.255 15.255 0 0013.268 13.215h.305A2.4 2.4 0 0016 13.536v-2.408A2.409 2.409 0 0014.018 8.8zm.4 4.817a.8.8 0 01-.273.6.843.843 0 01-.658.2A13.649 13.649 0 011.676 2.553a.875.875 0 01.2-.658.8.8 0 01.6-.273h2.412a.8.8 0 01.8.634q.048.329.12.65a8.928 8.928 0 00.369 1.244l-1.124.522A.8.8 0 004.66 5.74a11.634 11.634 0 005.62 5.62.851.851 0 001.068-.418l.5-1.124a10.992 10.992 0 001.269.369q.321.072.65.12a.8.8 0 01.634.8z"
                fill="#fff"
            />
        </svg>
    );
};

export default Phone;
